import React, { FC } from 'react';
import { IconProps } from '../../../atoms/Icon';
import { ToggleButtonProps } from '../../../atoms/ToggleButton';
import * as SC from './styled';
export type FormFieldToggleButtonProps = ToggleButtonProps & {
  name: string;
  checked?: boolean;
  helpText?: string;
  error?: string;
  hasError?: boolean;
  icon?: IconProps | any;
  image?: string | any;
  subtitle?: string | any;
};
const FormFieldToggleButton: FC<FormFieldToggleButtonProps> = ({
  error,
  helpText,
  icon,
  image,
  subtitle,
  ...toggleButton
}) => {
  return <SC.Container>
      <SC.Button {...toggleButton} iconBtn={icon} imageBtn={image} subtitleBtn={subtitle} />
      {!error && helpText && <SC.Help>{helpText}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Container>;
};
export default FormFieldToggleButton;